<template>
  <div class="goodsInfoWrap">
    <div @click="close" class="shadow"></div>
    <div class="goodsInfo">
      <div class="currentGoods">
        <img :src="info.img_main_path" class="logo" />
        <div class="right">
          <p>{{info.name}}</p>
          <p>¥{{info.money}}</p>
        </div>
      </div>
      <div class="numInfo">
        <p class="label">购买数量</p>
        <div class="stepBox flex-js-ac">
          <div @click.stop="addToCart(0)" class="subtract stepBtn"></div>
          <div class="num">{{num}}</div>
          <div @click.stop="addToCart(1)" class="can add stepBtn"></div>
        </div>
      </div>
      <div @click="close" class="close"></div>
      <div @click="confirmClick" class="submitBtn">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: Object,
  },
  name: 'skuIntegral',
  data () {
    return {
      num: 1
    }
  },
  created: function () {
  },
  methods: {
    // 商品数量加减
    addToCart(type) {
      if (type) {
        if (this.info.exchangenum <= this.num) {
          this.$toast('超过最大可兑换数量')
          return
        }
        this.num += 1
      } else if (this.num > 1) {
        this.num += -1
      }
    },
    close() {
      this.$emit('closeSku')
    },
    confirmClick() {
      this.$emit('changeNumber', this.num)
    }
  }

}
</script>

<style lang="scss" scoped>
  .close {
    position: absolute;
    top: 0.16rem;
    right: 0.16rem;
    width: 0.22rem;
    height: 0.22rem;
    background: url("../../assets/images/close3.png") no-repeat;
    background-size: 100%;
  }
  .shadow {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7)
  }
  .goodsInfo {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 3.34rem;
    padding: 0.16rem;
    font-size: 0.14rem;
    background: #fff;
    .currentGoods {
      display: flex;
      .logo {
        width: 0.96rem;
        height: 0.96rem;
      }
      .right {
        padding: 0.08rem 0 0.06rem 0.15rem;
      }
    }
    .numInfo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.1rem;
      padding: 0.12rem 0;
      .label {
        color: #333;
        font-weight: 600;
      }
      .stepBox{
        width: 0.86rem;
        height: 0.22rem;
        border: 1px solid #E5E5E5;
        text-align: center;
        border-radius: 0.14rem;
        .add, .subtract{
          width: 0.24rem;
          height: 100%;
        }

        .subtract{
          background: url(../../../static/images/productList/icon-subtract.png) no-repeat;
          background-size: 0.09rem;
          background-position: 0.06rem 0.05rem;
          &.can{
            background: url(../../../static/images/productList/icon-subtract-disabled.png) no-repeat;
            background-size: 0.09rem;
            background-position: 0.06rem 0.05rem;
          }
        }
        .add{
          background: url(../../../static/images/productList/icon-add-disabled.png) no-repeat;
          background-size: 0.09rem;
          background-position: 0.06rem 0.05rem;
          &.can{
            background: url(../../../static/images/productList/icon-add.png) no-repeat;
            background-size: 0.09rem;
            background-position: 0.06rem 0.05rem;
          }
        }
        .num{
          width: 0.36rem;
          height: 100%;
          background: #EEEFF4;
          color: #333;
        }
      }
    }
    .submitBtn {
      position: absolute;
      left: 0.16rem;
      right: 0.16rem;
      bottom: 0.08rem;
      line-height: 0.4rem;
      background: linear-gradient(90deg, #fc0324 0%, #f63a66 100%);
      color: #fff;
      text-align: center;
      border-radius: 0.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/skuIntegral.vue